import {Dialog, Transition} from "@headlessui/react";
import React, {Fragment} from "react";
import {MdClose} from "react-icons/md";

const ModalCreateActivity = ({
  show,
  close,
  submit,
  nameActivityValue,
  setNameActivityValue,
  commissionType,
  setCommissionType,
  feeCommissionValue,
  setFeeCommissionValue,
}) => {
  return (
    <Transition appear show={show} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={close}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-50" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all">
                <Dialog.Title
                  as="div"
                  className="text-lg text-center font-medium leading-6 text-gray-900 p-8 pb-1"
                >
                  <h3>Add Data Category</h3>
                  <div
                    onClick={close}
                    className="rounded-full p-0.5 top-2 right-2 bg-gray-200 absolute"
                    role="button"
                  >
                    <MdClose className="relative" />
                  </div>
                </Dialog.Title>
                <form autoComplete="off" noValidate onSubmit={submit}>
                  <div className="mt-2 border-t-2">
                    <div className="text-sm p-6 text-gray-500">
                      <div className="flex flex-row items-center">
                        <label htmlFor="name" className="font-semibold w-28">
                          Activity Name
                        </label>
                        <input
                          type="text"
                          name="name"
                          id="name"
                          className="bg-transparent border-2 ml-5 mb-5 grow border-gray-200 rounded-lg px-3 py-2"
                          value={nameActivityValue}
                          onChange={(e) => setNameActivityValue(e.target.value)}
                        />
                      </div>
                      <div className="flex flex-row items-center">
                        <label
                          htmlFor="category"
                          className="font-semibold w-28"
                        >
                          Commission Type
                        </label>
                        <select
                          className="bg-transparent border-2 ml-5 mb-5 grow border-gray-200 rounded-lg px-3 py-2"
                          defaultValue={"nominal"}
                          id="category"
                          onChange={(e) => setCommissionType(e.target.value)}
                        >
                          <option value="nominal" className="text-black">
                            Nominal
                          </option>
                          <option value="percent" className="text-black">
                            Percent
                          </option>
                        </select>
                      </div>
                      <div className="flex flex-row items-center">
                        <label htmlFor="amount" className="font-semibold w-28">
                          Commission Fee
                        </label>
                        <div className="relative ml-5 grow">
                          {commissionType === "nominal" && (
                            <span className="text-gray-200 absolute top-2.5 left-2.5 bottom-0">
                              Rp
                            </span>
                          )}
                          <input
                            type="number"
                            name="amount"
                            id="amount"
                            className={`${
                              commissionType === "nominal"
                                ? "text-right pl-7 "
                                : "text-left pl-3 "
                            }bg-transparent border-2 w-full border-gray-200 rounded-lg pr-3 py-2`}
                            defaultValue={feeCommissionValue}
                            onChange={(e) =>
                              setFeeCommissionValue(e.target.value)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4 px-6 pb-6 flex justify-center">
                    <button
                      type="submit"
                      className="inline-flex justify-center rounded-md border border-transparent bg-green-100 px-4 py-2 text-sm font-medium text-green-900 hover:bg-green-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2 mr-4"
                      onClick={close}
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-red-100 px-4 py-2 text-sm font-medium text-red-900 hover:bg-red-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:ring-offset-2"
                      onClick={close}
                    >
                      Cancel
                    </button>
                  </div>
                </form>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalCreateActivity;
